import { ABDbFieldsLookupLayout, ABDbLayoutLookupLayout, ABPopupMessageLayout } from '../../../../common/lookups/Layouts/ABLayouts';
import { EDLookupLayout } from '../../../../common/lookups/Layouts/EDLayouts';
import { FreightChargeLookupLayout, IDWarehouseLookupLayout } from '../../../../common/lookups/Layouts/IdLayouts';
import { OMCodesLookupLayout } from '../../../../common/lookups/Layouts/OMLayouts';
import { POOrderHeaderDp, PORequisitionHeaderDP } from '../../../../common/lookups/Layouts/POLayouts';
import { ActivityLayout, CAJobLayout } from '../../../../common/lookups/Layouts/CALayouts';
import { AccountLookup, ACDepartmentLayout } from '../../../../common/lookups/Layouts/ACLayouts';
import { FAFundLayout } from '../../../../common/lookups/Layouts/FALayouts';
import { CodeLookupLayout, IMProductCategoryLookupLayout, ItemBuilderConfigLookup } from '../../../../common/lookups/Layouts/ImLayouts';

const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "CreationDatetime",
                "tableName": "OMTRANSACTIONDP",
                "label": "Creation Date Time",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Record",
                "tableName": "OMTRANSACTIONDP",
                "label": "Record",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreationUserId",
                "tableName": "OMTRANSACTIONDP",
                "label": "Created By",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDatetime",
                "tableName": "OMTRANSACTIONDP",
                "label": "Last Update Date Time",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateUserId",
                "tableName": "OMTRANSACTIONDP",
                "label": "Last Updated User",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "CompanyId",
                "tableName": "OMTRANSACTIONDP",
                "label": "Company Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "Module",
                "tableName": "OMTRANSACTIONDP",
                "label": "Module",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RecordType",
                "tableName": "OMTRANSACTIONDP",
                "label": "Record Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotCodeDefaultMethod",
                "tableName": "OMTRANSACTIONDP",
                "label": "Lot Code Default Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ItemAvailableWindow",
                "tableName": "OMTRANSACTIONDP",
                "label": "Item Available Window",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCreditLimit",
                "tableName": "OMTRANSACTIONDP",
                "label": "Customer Credit Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConfirmUserId",
                "tableName": "OMTRANSACTIONDP",
                "label": "Confirm User Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransactionNumberMethod",
                "tableName": "OMTRANSACTIONDP",
                "label": "Transaction Number Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceBasis",
                "tableName": "OMTRANSACTIONDP",
                "label": "Price Basis",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShowPrintWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Show Print Warning",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PriceLevelWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Price Level Warning",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ShipmentIdMethod",
                "tableName": "OMTRANSACTIONDP",
                "label": "Shipment Id Method",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Factored",
                "tableName": "OMTRANSACTIONDP",
                "label": "Factored",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "TransactionCreditLimit",
                "tableName": "OMTRANSACTIONDP",
                "label": "Transaction Credit Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "MonthlyCreditLimit",
                "tableName": "OMTRANSACTIONDP",
                "label": "Monthly Credit Limit",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode1",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode2",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode3",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode4",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCode5",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseLocation",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Location",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PopupMessage",
                "tableName": "OMTRANSACTIONDP",
                "label": "Popup Message",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SalesPersonWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Salesperson Warning",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ItemSalesDates",
                "tableName": "OMTRANSACTIONDP",
                "label": "Item Sales Dates",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotMethodShipments",
                "tableName": "OMTRANSACTIONDP",
                "label": "Lot Method Shipments",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LotPickSequenceShipments",
                "tableName": "OMTRANSACTIONDP",
                "label": "Lot Pick Sequence Shipments",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "LotSelectionTiming",
                "tableName": "OMTRANSACTIONDP",
                "label": "Lot Selection Timing",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AllowNegAvlItem",
                "tableName": "OMTRANSACTIONDP",
                "label": "Allow Neg Avl Item",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "LocationMethod",
                "tableName": "OMTRANSACTIONDP",
                "label": "Location Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FromStageItem",
                "tableName": "OMTRANSACTIONDP",
                "label": "From Stage Item",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AllowNegAvlLocation",
                "tableName": "OMTRANSACTIONDP",
                "label": "Allow Neg Avl Location",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
                "readOnly": true,
            },
            {
                "name": "FromStageLocation",
                "tableName": "OMTRANSACTIONDP",
                "label": "From Stage Location",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DefaultTax",
                "tableName": "OMTRANSACTIONDP",
                "label": "Default Tax",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DefaultPriceLevel",
                "tableName": "OMTRANSACTIONDP",
                "label": "Default Price Level",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FMTransferTiming",
                "tableName": "OMTRANSACTIONDP",
                "label": "FM Transfer Timing",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DefaultSalesPerson",
                "tableName": "OMTRANSACTIONDP",
                "label": "Default Salesperson",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "StageWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Stage Warning",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreditCheckOnStageChange",
                "tableName": "OMTRANSACTIONDP",
                "label": "Credit Check On Stage Change",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ACCommitUnits",
                "tableName": "OMTRANSACTIONDP",
                "label": "AC Commit Units",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SpTransactionDateFlag",
                "tableName": "OMTRANSACTIONDP",
                "label": "SP Transaction Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DefaultFxData",
                "tableName": "OMTRANSACTIONDP",
                "label": "Default FX Data",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseAlternateDescription",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Alternate Description",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseLineNumbers",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Line Numbers",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SpReferenceFieldFlag",
                "tableName": "OMTRANSACTIONDP",
                "label": "SP Reference Field",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountBasis",
                "tableName": "OMTRANSACTIONDP",
                "label": "Discount Basis",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AllowDuplicatePo",
                "tableName": "OMTRANSACTIONDP",
                "label": "Allow Duplicate PO",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "ShipToLookup",
                "tableName": "OMTRANSACTIONDP",
                "label": "Ship To",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


            {
                "name": "UnitOfMeasure",
                "tableName": "OMTRANSACTIONDP",
                "label": "Unit Of Measure",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCodeDetail1",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code Detail 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCodeDetail2",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code Detail 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCodeDetail3",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code Detail 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCodeDetail4",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code Detail 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserDefinedCodeDetail5",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code Detail 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ReadOnlyWebFromStage",
                "tableName": "OMTRANSACTIONDP",
                "label": "Readonly Web From Stage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PresetLotCode",
                "tableName": "OMTRANSACTIONDP",
                "label": "Preset Lot Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CheckKitAvailability",
                "tableName": "OMTRANSACTIONDP",
                "label": "Check Kit Availability",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "KitDetailUsage",
                "tableName": "OMTRANSACTIONDP",
                "label": "Kit Detail Usage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ArDescriptionFlag",
                "tableName": "OMTRANSACTIONDP",
                "label": "AR Description Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "KitDetailUsageAdjustment",
                "tableName": "OMTRANSACTIONDP",
                "label": "Kit Detail Usage Adjustment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PONumberFrom",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Number From",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PONumberTo",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Number To",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PONumberLast",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Number Last",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PONumberExpiration",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Number Expiration",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PONumberIncrement",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Number Increment",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ItemVisibility",
                "tableName": "OMTRANSACTIONDP",
                "label": "Item Visibility",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PONumberMethod",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Number Method",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneePriceScheduleWh",
                "tableName": "OMTRANSACTIONDP",
                "label": "Consignee Price Schedule Wh",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerPriceScheduleWh",
                "tableName": "OMTRANSACTIONDP",
                "label": "Customer Price Schedule Wh",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CheckDuplicateItems",
                "tableName": "OMTRANSACTIONDP",
                "label": "Check Duplicate Items",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "DiscPriceWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Disc Price Warning",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseCommitDateForFyfp",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Commit Date For FYFP",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AssociateSalesPeople",
                "tableName": "OMTRANSACTIONDP",
                "label": "Associate Sales People",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseQuantity",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Quantity",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UnitPriceFromDate",
                "tableName": "OMTRANSACTIONDP",
                "label": "Unit Price From Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseQuantityChange",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Quantity Change",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CheckDuplicateTrans",
                "tableName": "OMTRANSACTIONDP",
                "label": "Check Duplicate Trans",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SeparateFreight",
                "tableName": "OMTRANSACTIONDP",
                "label": "Separate Freight",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DefaultInvDate",
                "tableName": "OMTRANSACTIONDP",
                "label": "Default Inv Date",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "QuantityCheck",
                "tableName": "OMTRANSACTIONDP",
                "label": "Quantity Check",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DateValidation",
                "tableName": "OMTRANSACTIONDP",
                "label": "Date Validation",
                "type": "number",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "AllowUserValidation",
                "tableName": "OMTRANSACTIONDP",
                "label": "Allow User Validation",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "CreateDoContents",
                "tableName": "OMTRANSACTIONDP",
                "label": "Create DO Contents",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "POReqDropShip",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Req Dropship",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "POReqBackOrdered",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Req Backordered",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "POReqPurchased",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Req Purchased",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "POReqOrdered",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Req Ordered",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "PrintToPrinterPackingSlip",
                "tableName": "OMTRANSACTIONDP",
                "label": "Print To Printer Packing Slip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrintToPrinterPickingSlip",
                "tableName": "OMTRANSACTIONDP",
                "label": "Print To Printer Picking Slip",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrintToPrinterEditReport",
                "tableName": "OMTRANSACTIONDP",
                "label": "Print To Printer Edit Report",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PrintToPrinterOrderAcknowledge",
                "tableName": "OMTRANSACTIONDP",
                "label": "Print To Printer Order Acknowledge",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

            {
                "name": "PosCategory1",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory2",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory3",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory4",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory5",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 5",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory6",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 6",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory7",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 7",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory8",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 8",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory9",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 9",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory10",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 10",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory11",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 11",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosCategory12",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Category 12",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosGiftCategory",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Gift Category",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosNewGiftCard",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS New Gift Card",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PosAddValueGiftCard",
                "tableName": "OMTRANSACTIONDP",
                "label": "POS Add Value Gift Card",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UseDiscountFromVcr",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Discount From VCR",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DisplayDiscountFromVcr",
                "tableName": "OMTRANSACTIONDP",
                "label": "Display Discount From VCR",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DateValidationUdDates",
                "tableName": "OMTRANSACTIONDP",
                "label": "Date Validation UD Dates",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ItemLotNetAvailWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Item Lot Net Avail Warning",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SelectItemsFilter1",
                "tableName": "OMTRANSACTIONDP",
                "label": "Select Items Filter 1",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SelectItemsFilter2",
                "tableName": "OMTRANSACTIONDP",
                "label": "Select Items Filter 2",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SelectItemsFilter3",
                "tableName": "OMTRANSACTIONDP",
                "label": "Select Items Filter 3",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SelectItemsFilter4",
                "tableName": "OMTRANSACTIONDP",
                "label": "Select Items Filter 4",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RapidEntry",
                "tableName": "OMTRANSACTIONDP",
                "label": "Rapid Entry",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RapidEntryStage",
                "tableName": "OMTRANSACTIONDP",
                "label": "Rapid Entry Stage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },



            {
                "name": "AutoCalcFreight",
                "tableName": "OMTRANSACTIONDP",
                "label": "Auto Calc Freight",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "PtrAssignedStageFlag",
                "tableName": "OMTRANSACTIONDP",
                "label": "PTR Assigned Stage Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "InventoryReview",
                "tableName": "OMTRANSACTIONDP",
                "label": "Inventory Review",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ItemBuilderFlag",
                "tableName": "OMTRANSACTIONDP",
                "label": "Item Builder Flag",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "FMTransferStage",
                "tableName": "OMTRANSACTIONDP",
                "label": "FM Transfer Stage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "IncludeDiscountInUnitPrice",
                "tableName": "OMTRANSACTIONDP",
                "label": "Include Discount In Unit Price",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DetailStatus",
                "tableName": "OMTRANSACTIONDP",
                "label": "Detail Status",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DisplayCustomFees",
                "tableName": "OMTRANSACTIONDP",
                "label": "Display Custom Fees",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DisplayCustomFeesTab",
                "tableName": "OMTRANSACTIONDP",
                "label": "Display Custom Fees Tab",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "UserCustomFeesP",
                "tableName": "OMTRANSACTIONDP",
                "label": "User Custom Fee SP",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SplitOption",
                "tableName": "OMTRANSACTIONDP",
                "label": "Split Option",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ImportDetailLineStage",
                "tableName": "OMTRANSACTIONDP",
                "label": "Import Detail Line Stage",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },

        ]
    },
    {
        "groupId": 2,
        "fields": [{
                "name": "ProfileCode",
            "tableName": "OMTRANSACTIONDP",
            "label": "Profile",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
                "name": "ArTradeDiscountFlag",
            "tableName": "OMTRANSACTIONDP",
            "label": "AR Trade Discount",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        ]
    },
    {
        "groupId": 3,
        "fields": [{
                "name": "Description",
            "tableName": "OMTRANSACTIONDP",
            "label": "Description",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
                "name": "PrintToPrinterInvoice",
            "tableName": "OMTRANSACTIONDP",
            "label": "Invoice",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "Approval",
                "tableName": "OMTRANSACTIONDP",
                "label": "Approval",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "BOStatus",
                "tableName": "OMTRANSACTIONDP",
                "label": "BO Status",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
];
const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "Record",
                "tableName": "OMTRANSACTIONDP",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,   

            },
            {
                "name": "ProfileCode",
                "tableName": "OMTRANSACTIONDP",
                "label": "Profile",
                "type": "text",
                "required": true,
                "visible": true
            },
            {
                "name": "Description",
                "tableName": "OMTRANSACTIONDP",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true
            },
            {
                "name": "PopupMessage",
                "tableName": "OMTRANSACTIONDP",
                "label": "Popup Msg",
                "type": "lookup",
                "layout": ABPopupMessageLayout({ tableName: 'OMTRANSACTIONDP' }),
                "required": false,
                "visible": true,
                "acceptCustomValue": true,

            },
            {
                "name": "Comment",
                "tableName": "OMTRANSACTIONDP",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 2,
        "label": "User Defined Codes",
        "fields": [
            {
                "name": "UserDefinedCode1",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 1",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '18' }),"lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }, {
                "name": "UserDefinedCode2",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 2",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '19' }),"lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "acceptCustomValue": true,

            }, {
                "name": "UserDefinedCode3",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 3",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '20' }),"lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }, {
                "name": "UserDefinedCode4",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 4",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '21' }),"lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }, {
                "name": "UserDefinedCode5",
                "tableName": "OMTRANSACTIONDP",
                "label": "Code 5",
                "type": "lookup",
                "layout": OMCodesLookupLayout({ codeType: '22' }),"lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            }
        ]
    }
];
const HeaderLayout = [
    {
        "groupId": 1,
        "label": "Access Fields",
        "fields": [
            {
                "name": "AccessPriceLevel",
                "tableName": "OMTRANSACTIONDP",
                "label": "Price Level",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "AccessTermsCode",
                "tableName": "OMTRANSACTIONDP",
                "label": "Terms Code",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "AccessTaxCode",
                "tableName": "OMTRANSACTIONDP",
                "label": "Tax Code",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Freight Management Interface",
        "fields": [
            {
                "name": "FMTransferTiming",
                "tableName": "OMTRANSACTIONDP",
                "label": "Timing",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "CreateDoContents",
                "tableName": "OMTRANSACTIONDP",
                "label": "Create Content",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "FMTransferStage",
                "tableName": "OMTRANSACTIONDP",
                "label": "FM Transfer Stage",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Credit Validation",
        "fields": [
            {
                "name": "CustomerCreditLimit",
                "tableName": "OMTRANSACTIONDP",
                "label": "Credit Limit",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "CreditCheckOnStageChange",
                "tableName": "OMTRANSACTIONDP",
                "label": "On Stage",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    ,
    {
        "groupId": 4,
        "label": "Back Order Defaults",
        "fields": [
            {
                "name": "BoTransactionNumberMethod",
                "tableName": "OMTRANSACTIONDP",
                "label": "New Trans #",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "BoStatus",
                "tableName": "OMTRANSACTIONDP",
                "label": "BO Status",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 5,
        "label": "Discount Basis Calculation",
        "fields": [
            {
                "name": "DiscountBasis",
                "tableName": "OMTRANSACTIONDP",
                "label": "Discount Basis",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 6,
        "label": "Approval Based on Credit Review",
        "fields": [
            {
                "name": "Approval",
                "tableName": "OMTRANSACTIONDP",
                "label": "Approval",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 7,
        "label": "Allow Duplicate PO",
        "fields": [
            {
                "name": "AllowDuplicatePo",
                "tableName": "OMTRANSACTIONDP",
                "label": "Allow Dup. PO",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 8,
        "label": "Warning Window",
        "fields": [
            {
                "name": "SalesPersonWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Salesperson",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 9,
        "label": "PO Interface",
        "fields": [
            {
                "name": "RPODefaultProfile",
                "tableName": "OMTRANSACTIONDP",
                "label": "PO Profile",
                "type": "lookup",
                "layout": POOrderHeaderDp,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
            },
            {
                "name": "RRequisitionDefaultProfile",
                "tableName": "OMTRANSACTIONDP",
                "label": "Req. Profile",
                "type": "lookup",
                "layout": PORequisitionHeaderDP,
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 10,
        "label": "Assigned/Picked Stages Wrning",
        "fields": [
            {
                "name": "StageWarning",
                "tableName": "OMTRANSACTIONDP",
                "label": "Show Warning",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "StageWarningComment",
                "tableName": "OMTRANSACTIONDP",
                "label": "Message",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
            }
        ]
    }
    , {
        "groupId": 11,
        "label": "Vendor Cross Reference",
        "fields": [
            {
                "name": "UseDiscountFromVcr",
                "tableName": "OMTRANSACTIONDP",
                "label": "Use Discount",
                "type": "select",
                "required": false,
                "visible": true,
            },
            {
                "name": "DisplayDiscountFromVcr",
                "tableName": "OMTRANSACTIONDP",
                "label": "Display Discount",
                "type": "select",
                "required": false,
                "visible": true,
                readOnly: true,
            }
        ]
    }
    , {
        "groupId": 12,
        "label": "Dt Validation +/- in Dys",
        "fields": [
            {
                "name": "DateValidation",
                "tableName": "OMTRANSACTIONDP",
                "label": "Date Validation",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
            },
            {
                "name": "DateValidationUdDates",
                "tableName": "OMTRANSACTIONDP",
                "label": "UD Dates",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 13,
        "label": "Lookups",
        "fields": [
            {
                "name": "ShipToLookup",
                "tableName": "OMTRANSACTIONDP",
                "label": "Ship To",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 14,
        "label": "Status Check Based On Stage",
        "fields": [
            {
                "name": "StatusCheck",
                "tableName": "OMTRANSACTIONDP",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 15,
        "label": "Check Duplicate Transaction",
        "fields": [
            {
                "name": "CheckDuplicateTrans",
                "tableName": "OMTRANSACTIONDP",
                "label": "Check Duplicate",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }, {
        "groupId": 16,
        "label": "Validation",
        "fields": [
            {
                "name": "AllowUserValidation",
                "tableName": "OMTRANSACTIONDP",
                "label": "Execute Proc",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }, {
        "groupId": 17,
        "label": "Dates",
        "fields": [
            {
                "name": "UseCommitDateForFyfp",
                "tableName": "OMTRANSACTIONDP",
                "label": "UseCommit Date",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 18,
        "label": "Detail Summary",
        "fields": [
            {
                "name": "DetailStatus",
                "tableName": "OMTRANSACTIONDP",
                "label": "Dtl Status",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
    , {
        "groupId": 19,
        "label": "Split",
        "fields": [
            {
                "name": "SplitOption",
                "tableName": "OMTRANSACTIONDP",
                "label": "Split Option",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    }
];
const DetailsLayout = [
    {
        groupId: 1,
        label: "Quantity Status Check By Stage",
        fields: [
            { name: "StatusCheckPending", tableName: "OMTRANSACTIONDP", label: "Pending", type: "select", required: false, visible: true },
            { name: "StatusCheckAssigned", tableName: "OMTRANSACTIONDP", label: "Assigned", type: "select", required: false, visible: true },
            { name: "StatusCheckPicked", tableName: "OMTRANSACTIONDP", label: "Picked", type: "select", required: false, visible: true },
            { name: "StatusCheckCompleted", tableName: "OMTRANSACTIONDP", label: "Completed", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 2,
        label: "Location - Allocation Method",
        fields: [
            { name: "LocationMethod", tableName: "OMTRANSACTIONDP", label: "Method", type: "select", required: false, visible: true },
            { name: "LocationPickMethod", tableName: "OMTRANSACTIONDP", label: "Pick Method", type: "select", required: false, visible: true },
            { name: "LocationPickSequence", tableName: "OMTRANSACTIONDP", label: "Pick Seq.", type: "select", required: false, visible: true},
            { name: "FromStageLocation", tableName: "OMTRANSACTIONDP", label: "From Stage", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 9,
        label: "Item/Lot - Warning Window",
        fields: [
            { name: "PriceLevelWarning", tableName: "OMTRANSACTIONDP", label: "Minimum Price", type: "select", required: false, visible: true },
            { name: "ItemSalesDates", tableName: "OMTRANSACTIONDP", label: "Item Avl Date", type: "select", required: false, visible: true },
            { name: "CheckDuplicateItems", tableName: "OMTRANSACTIONDP", label: "Duplicate Item", type: "select", required: false, visible: true },
            { name: "DiscPriceWarning", tableName: "OMTRANSACTIONDP", label: "Disc. Warning", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 10,
        label: "Price Calculation",
        fields: [
            { name: "UseQuantity", tableName: "OMTRANSACTIONDP", label: "Unit Price", type: "select", required: false, visible: true },
            { name: "UseQuantityChange", tableName: "OMTRANSACTIONDP", label: "Unit Price Effect", type: "select", required: false, visible: true },
            { name: "UnitPriceFromDate", tableName: "OMTRANSACTIONDP", label: "Calc. Price", type: "select", required: false, visible: true },
            { name: "IncludeDiscountInUnitPrice", tableName: "OMTRANSACTIONDP", label: "Incl Dscnt In F", type: "select", required: false, visible: true }
        ]
    },

    {
        groupId: 5,
        label: "Lot - Allocation Method",
        fields: [
            { name: "LotMethodShipments", tableName: "OMTRANSACTIONDP", label: "Method", type: "select", required: false, visible: true },
            { name: "LotCodeDefaultMethod", tableName: "OMTRANSACTIONDP", label: "Pick Method", type: "select", required: false, visible: true },
            { name: "LotPickSequenceShipments", tableName: "OMTRANSACTIONDP", label: "Pick Seq.", type: "select", required: false, visible: true },
            { name: "LotSelectionTiming", tableName: "OMTRANSACTIONDP", label: "From Stage", type: "select", required: false, visible: true },
            { name: "PresetLotCode", tableName: "OMTRANSACTIONDP", label: "Preset Code", type: "text", required: false, visible: true, readOnly: true }
        ]
    },
    {
        groupId: 6,
        label: "Original Order Quantity",
        fields: [
            { name: "OriginalOrderQuantityTiming", tableName: "OMTRANSACTIONDP", label: "Timing", type: "select", required: false, visible: true },
            { name: "OriginalOrderQuantityAccess", tableName: "OMTRANSACTIONDP", label: "Access", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 7,
        label: "Item/Lot - Access Fields",
        fields: [
            { name: "AccessUnitPrice", tableName: "OMTRANSACTIONDP", label: "Unit Price", type: "select", required: false, visible: true },
            { name: "AccessProductCategory", tableName: "OMTRANSACTIONDP", label: "Prod Category", type: "select", required: false, visible: true },
            { name: "AccessTaxableFlag", tableName: "OMTRANSACTIONDP", label: "Taxable", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 8,
        label: "Custom Fees",
        fields: [
            { name: "DisplayCustomFees", tableName: "OMTRANSACTIONDP", label: "Detail Display", type: "select", required: false, visible: true },
            { name: "DisplayCustomFeesTab", tableName: "OMTRANSACTIONDP", label: "Tab Display", type: "select", required: false, visible: true },
            { name: "UserCustomFeesP", tableName: "OMTRANSACTIONDP", label: "Usr Custom SP", type: "select", required: false, visible: true }
        ]
    },

    {
        groupId: 11,
        label: "Location Grid Auto Access",
        fields: [
            { name: "AllowNegAvlLocation", tableName: "OMTRANSACTIONDP", label: "Allow (-) Avl", type: "select", required: false, visible: true },
            { name: "AccessLocationGrid", tableName: "OMTRANSACTIONDP", label: "Access Grid", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 3,
        label: "Qty Check when Qty Reduced",
        fields: [
            { name: "QuantityCheck", tableName: "OMTRANSACTIONDP", label: "Quantity Check", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 4,
        label: "Select Items/Lots",
        fields: [
            { name: "ItemLotNetAvailWarning", tableName: "OMTRANSACTIONDP", label: "Net Available", type: "select", required: false, visible: true }
        ]
    },
];

const DefaultsLayout = [
    {
        groupId: 1,
        label: "Header Defaults",
        fields: [
            { name: "TransactionNumberMethod", tableName: "OMTRANSACTIONDP", label: "Transaction #", type: "select", required: false, visible: true },
            { name: "OmPrefix", tableName: "OMTRANSACTIONDP", label: "Prefix", type: "text", required: false, visible: true },
            { name: "DefaultTerms", tableName: "OMTRANSACTIONDP", label: "Terms", type: "select", required: false, visible: true },
            { name: "DefaultTax", tableName: "OMTRANSACTIONDP", label: "Tax Code", type: "select", required: false, visible: true },
            { name: "DefaultPriceLevel", tableName: "OMTRANSACTIONDP", label: "Price Level", type: "select", required: false, visible: true },
            { name: "DefaultSalesPerson", tableName: "OMTRANSACTIONDP", label: "Salesperson", type: "select", required: false, visible: true },
            { name: "DefaultInvDate", tableName: "OMTRANSACTIONDP", label: "Default Invoice", type: "select", required: false, visible: true },
            { name: "DefaultFxData", tableName: "OMTRANSACTIONDP", label: "Default FX", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 2,
        label: "Item/Lot Defaults",
        fields: [
            { name: "RDefaultWh", tableName: "OMTRANSACTIONDP", label: "Warehouse", type: "lookup", "layout": IDWarehouseLookupLayout, required: false, visible: true },
            { name: "AccessBackOrderQuantity", tableName: "OMTRANSACTIONDP", label: "BO Quantity", type: "select", required: false, visible: true },
            { name: "PriceBasis", tableName: "OMTRANSACTIONDP", label: "Price Method", type: "select", required: false, visible: true },
            { name: "UserDefinedCodeDetail1", tableName: "OMTRANSACTIONDP", label: "Code 1", type: "lookup", "layout": OMCodesLookupLayout({ codeType: '12' }), required: false, visible: true },
            { name: "UserDefinedCodeDetail2", tableName: "OMTRANSACTIONDP", label: "Code 2", type: "lookup", "layout": OMCodesLookupLayout({ codeType: '13' }), required: false, visible: true },
            { name: "UserDefinedCodeDetail3", tableName: "OMTRANSACTIONDP", label: "Code 3", type: "lookup", "layout": OMCodesLookupLayout({ codeType: '14' }), required: false, visible: true },
            { name: "UserDefinedCodeDetail4", tableName: "OMTRANSACTIONDP", label: "Code 4", type: "lookup", "layout": OMCodesLookupLayout({ codeType: '15' }), required: false, visible: true },
            { name: "UserDefinedCodeDetail5", tableName: "OMTRANSACTIONDP", label: "Code 5", type: "lookup", "layout": OMCodesLookupLayout({ codeType: '16' }), required: false, visible: true },
            { name: "UnitOfMeasure", tableName: "OMTRANSACTIONDP", label: "UOM", type: "lookup", "layout": EDLookupLayout({ Dataelementnum: '355', Versionid: '4010' }), required: false, visible: true },
            { name: "ArTradeDiscountFlag", tableName: "OMTRANSACTIONDP", label: "Trade Disc", type: "select", required: false, visible: true },
            { name: "ArTermsDiscountFlag", tableName: "OMTRANSACTIONDP", label: "AR Terms", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 5,
        label: "PO Default Requisition Items",
        fields: [
            { name: "POReqDropShip", tableName: "OMTRANSACTIONDP", label: "Drop Ship", type: "select", required: false, visible: true },
            { name: "POReqBackOrdered", tableName: "OMTRANSACTIONDP", label: "Back Ordered", type: "select", required: false, visible: true },
            { name: "POReqPurchased", tableName: "OMTRANSACTIONDP", label: "Purchased", type: "select", required: false, visible: true },
            { name: "POReqOrdered", tableName: "OMTRANSACTIONDP", label: "Ordered", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 4,
        label: "Location Defaults",
        fields: [
            { name: "RDefaultLocationWh", tableName: "OMTRANSACTIONDP", label: "Location WH", type: "lookup", "layout": IDWarehouseLookupLayout, required: false, visible: true }
        ]
    }
];

const MiscLayout = [
    {
        groupId: 2,
        label: "Commissions Record",
        fields: [
            { name: "SpTransactionDateFlag", tableName: "OMTRANSACTIONDP", label: "SP Tran Date", type: "select", required: false, visible: true },
            { name: "SpReferenceFieldFlag", tableName: "OMTRANSACTIONDP", label: "SP Reference", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 8,
        label: "Freight Totals",
        fields: [
            { name: "SeparateFreight", tableName: "OMTRANSACTIONDP", label: "Separate Freight", type: "select", required: false, visible: true },
            { name: "AccessFreight", tableName: "OMTRANSACTIONDP", label: "Access Frt Tot", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 9,
        label: "Freight Auto-Calculation",
        fields: [
            { name: "AutoCalcFreight", tableName: "OMTRANSACTIONDP", label: "Auto Calc Frt", type: "select", required: false, visible: true },
            { name: "RChargeCodeFreight", tableName: "OMTRANSACTIONDP", label: "Frt Chrg Code", type: "lookup", layout: FreightChargeLookupLayout, required: false, visible: true}
        ]
    },
    {
        groupId: 10,
        label: "Detail Import",
        fields: [
            { name: "RImportLayout", tableName: "OMTRANSACTIONDP", label: "Import Layout", type: "lookup", "layout": ABDbLayoutLookupLayout({layoutId:'73BF518B-9CD1-49FB-BA81-DB9479A25DD2'}), required: false, visible: true },
            { name: "ImportDetailLineStage", tableName: "OMTRANSACTIONDP", label: "Imp Detail Line Stage", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 1,
        label: "AC Commit Units",
        fields: [
            { name: "ACCommitUnits", tableName: "OMTRANSACTIONDP", label: "Units", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 3,
        label: "Read-Only on Web",
        fields: [
            { name: "ReadOnlyWebFromStage", tableName: "OMTRANSACTIONDP", label: "From Stage", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 12,
        label: "Associate Salesperson",
        fields: [
            { name: "AssociateSalesPeople", tableName: "OMTRANSACTIONDP", label: "Salesperson", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 13,
        label: "Import Layouts",
        fields: [
            { name: "RLayoutId", tableName: "OMTRANSACTIONDP", label: "Serial N Import", type: "lookup", "layout": ABDbLayoutLookupLayout({layoutId:'57FE4437-3A57-492F-B62D-9F0FC35D7161'}),"lookupDisplayMode": "grid", required: false, visible: true }
        ]
    },
    {
        groupId: 5,
        label: "Select Items - Expr Tab Default Values",
        fields: [
            { name: "SelectItemsFilter1", tableName: "OMTRANSACTIONDP", label: "Filter 1", type: "lookup","layout": ABDbFieldsLookupLayout, required: false, visible: true },
            { name: "SelectItemsFilter2", tableName: "OMTRANSACTIONDP", label: "Filter 2", type: "lookup","layout": ABDbFieldsLookupLayout, required: false, visible: true },
            { name: "SelectItemsFilter3", tableName: "OMTRANSACTIONDP", label: "Filter 3", type: "lookup","layout": ABDbFieldsLookupLayout, required: false, visible: true },
            { name: "SelectItemsFilter4", tableName: "OMTRANSACTIONDP", label: "Filter 4", type: "lookup","layout": ABDbFieldsLookupLayout, required: false, visible: true }
        ]
    },
    {
        groupId: 6,
        label: "OM → PM Produce To Order",
        fields: [
            { name: "CheckKitAvailability", tableName: "OMTRANSACTIONDP", label: "Check Avail.", type: "select", required: false, visible: true },
            { name: "KitDetailUsage", tableName: "OMTRANSACTIONDP", label: "Reserve Kit", type: "select", required: false, visible: true },
            { name: "KitDetailUsageAdjustment", tableName: "OMTRANSACTIONDP", label: "Usage Adjust.", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 7,
        label: "Price Schedule",
        fields: [
            { name: "ItemVisibility", tableName: "OMTRANSACTIONDP", label: "Item Visibility", type: "select", required: false, visible: true },
            { name: "CustomerPriceScheduleWh", tableName: "OMTRANSACTIONDP", label: "Cust. Use WH", type: "select", required: false, visible: true },
            { name: "ConsigneePriceScheduleWh", tableName: "OMTRANSACTIONDP", label: "Cons. Use WH", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 14,
        label: "PTR",
        fields: [
            { name: "PtrAssignedStageFlag", tableName: "OMTRANSACTIONDP", label: "PTR Assigned", type: "select", required: false, visible: true }
        ]
    },

    {
        groupId: 11,
        label: "PO# Automatic Generation",
        fields: [
            { name: "PONumberMethod", tableName: "OMTRANSACTIONDP", label: "PO# Method", type: "select", required: false, visible: true },
            { name: "PONumberFrom", tableName: "OMTRANSACTIONDP", label: "PO# - From", type: "text", required: false, visible: true },
            { name: "PONumberTo", tableName: "OMTRANSACTIONDP", label: "PO# - To", type: "text", required: false, visible: true },
            { name: "PONumberLast", tableName: "OMTRANSACTIONDP", label: "PO# Last", type: "text", required: false, visible: true },
            { name: "PONumberExpiration", tableName: "OMTRANSACTIONDP", label: "Exp. Date", type: "date", required: false, visible: true },
            { name: "PONumberIncrement", tableName: "OMTRANSACTIONDP", label: "PO# Increm.", type: "number", format: "#,###0.00", required: false, visible: true },
            { name: "LineNumberIncrement", tableName: "OMTRANSACTIONDP", label: "Line # Incr.", type: "number",format: "#,###0.00", required: false, visible: true }
        ]
    },
    {
        groupId: 4,
        label: "Details",
        fields: [
            { name: "ArDescriptionFlag", tableName: "OMTRANSACTIONDP", label: "AR Description", type: "select", required: false, visible: true },
            { name: "UseAlternateDescription", tableName: "OMTRANSACTIONDP", label: "Use Alt. Desc.", type: "select", required: false, visible: true },
            { name: "UseLineNumbers", tableName: "OMTRANSACTIONDP", label: "Use Line #", type: "select", required: false, visible: true },
            { name: "LineNumberIncrement", tableName: "OMTRANSACTIONDP", label: "Line # Incr.", type: "number",format: "#,###0.00", required: false, visible: true },
            { name: "RapidEntry", tableName: "OMTRANSACTIONDP", label: "Rapid Entry", type: "select", required: false, visible: true },
            { name: "RapidEntryStage", tableName: "OMTRANSACTIONDP", label: "Rapid Stage", type: "select", required: false, visible: true},
        ]
    },
    {
        groupId: 16,
        label: "Item Builder",
        fields: [
            { name: "ItemBuilderFlag", tableName: "OMTRANSACTIONDP", label: "Item Builder Flag", type: "select", required: false, visible: true },
            { name: "RItemBuilderConfig", tableName: "OMTRANSACTIONDP", label: "Item Builder Code", type: "lookup", "layout": ItemBuilderConfigLookup, required: false, visible: true }
        ]
    },
    {
        groupId: 15,
        label: "Pending Inventory Review",
        fields: [
            { name: "InventoryReview", tableName: "OMTRANSACTIONDP", label: "Inv Review", type: "select", required: false, visible: true }
        ]
    }
];

const PrintFormatLayout = [
    {
        groupId: 3,
        label: "POS Button Categories",
        fields: [
            { name: "PosCategory1", tableName: "OMTRANSACTIONDP", label: "POS Category 1", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory2", tableName: "OMTRANSACTIONDP", label: "POS Category 2", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory3", tableName: "OMTRANSACTIONDP", label: "POS Category 3", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory4", tableName: "OMTRANSACTIONDP", label: "POS Category 4", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory5", tableName: "OMTRANSACTIONDP", label: "POS Category 5", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory6", tableName: "OMTRANSACTIONDP", label: "POS Category 6", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory7", tableName: "OMTRANSACTIONDP", label: "POS Category 7", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory8", tableName: "OMTRANSACTIONDP", label: "POS Category 8", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory9", tableName: "OMTRANSACTIONDP", label: "POS Category 9", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory10",tableName: "OMTRANSACTIONDP", label: "POS Category 10",type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory11",tableName: "OMTRANSACTIONDP", label: "POS Category 11",type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosCategory12",tableName: "OMTRANSACTIONDP", label: "POS Category 12",type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true }
        ]
    },
    {
        groupId: 1,
        label: "Reports Formats",
        fields: [
            { name: "EditReportFormat", tableName: "OMTRANSACTIONDP", label: "Edit Report", type: "select", required: false, visible: true },
            { name: "PickSlipFormat", tableName: "OMTRANSACTIONDP", label: "Picking Slip", type: "select", required: false, visible: true },
            { name: "PickSlipFormat2", tableName: "OMTRANSACTIONDP", label: "Packing Slip", type: "select", required: false, visible: true },
            { name: "InvoiceFormat", tableName: "OMTRANSACTIONDP", label: "Invoice", type: "select", required: false, visible: true },
            { name: "OrderAcknFormat", tableName: "OMTRANSACTIONDP", label: "Order Acknowledge", type: "select", required: false, visible: true },
            { name: "ARFormat", tableName: "OMTRANSACTIONDP", label: "AR Det. Aging", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 2,
        label: "Quick Print To Printer",
        fields: [
            { name: "PrintToPrinterEditReport", tableName: "OMTRANSACTIONDP", label: "Edit Report", type: "select", required: false, visible: true },
            { name: "PrintToPrinterPickingSlip", tableName: "OMTRANSACTIONDP", label: "Picking Slip", type: "select", required: false, visible: true },
            { name: "PrintToPrinterPackingSlip", tableName: "OMTRANSACTIONDP", label: "Packing Slip", type: "select", required: false, visible: true },
            { name: "PrintToPrinterInvoice", tableName: "OMTRANSACTIONDP", label: "Invoice", type: "select", required: false, visible: true },
            { name: "PrintToPrinterOrderAcknowledge", tableName: "OMTRANSACTIONDP", label: "Order Acknowledge", type: "select", required: false, visible: true }
        ]
    },
    {
        groupId: 4,
        label: "POS Gift Card",
        fields: [
            { name: "PosGiftCategory", tableName: "OMTRANSACTIONDP", label: "Gift Card Cat.", type: "lookup", "layout": CodeLookupLayout({codeType:'01'}), required: false, visible: true },
            { name: "PosNewGiftCard", tableName: "OMTRANSACTIONDP", label: "POS New Gift Card", type: "lookup", "layout": CodeLookupLayout({codeType:'02'}), required: false, visible: true },
            { name: "PosAddValueGiftCard", tableName: "OMTRANSACTIONDP", label: "POS Add Value Gift Card", type: "lookup", "layout": CodeLookupLayout({codeType:'02'}), required: false, visible: true }
        ]
    },
    {
        groupId: 5,
        label: "POS Non Inventory",
        fields: [
            { name: "RNonInvProductCategory", tableName: "OMTRANSACTIONDP", label: "Non Inv Prod Cat.", type: "lookup", "layout": IMProductCategoryLookupLayout(), required: false, visible: true }
        ]
    }
   
];

const AccountingLayout = [
    {
        groupId: 1,
        label: "Account",
        fields: [
            { name: "RDiscountAccount", tableName: "OMTRANSACTIONDP", label: "", type: "lookup", "layout": AccountLookup,"lookupDisplayMode": "grid", required: false, visible: true }
        ]
    },
    {
        groupId: 2,
        label: "Department",
        fields: [
            { name: "RDiscountDepartment", tableName: "OMTRANSACTIONDP", label: "", type: "lookup", "layout": ACDepartmentLayout,"lookupDisplayMode": "grid", required: false, visible: true }
        ]
    },
    {
        groupId: 3,
        label: "Fund",
        fields: [
            { name: "RDiscountFund", tableName: "OMTRANSACTIONDP", label: "", type: "lookup", "layout": FAFundLayout,"lookupDisplayMode": "grid", required: false, visible: true }
        ]
    },
    {
        groupId: 4,
        label: "Job",
        fields: [
            { name: "RDiscountJob", tableName: "OMTRANSACTIONDP", label: "", type: "lookup", "layout": CAJobLayout,"lookupDisplayMode": "grid", required: false, visible: true }
        ]
    },
    {
        groupId: 5,
        label: "Activity",
        fields: [
            { name: "RDiscountActivity", tableName: "OMTRANSACTIONDP", label: "", type: "lookup", "layout": ActivityLayout,"lookupDisplayMode": "grid", required: false, visible: true }
        ]
    }
]

export {
    SearchLayout,
    PrimaryLayout,
    DetailsLayout,
    DefaultsLayout,
    MiscLayout,
    PrintFormatLayout,
    HeaderLayout,
    AccountingLayout,

}